import React from 'react';
import PropTypes from 'prop-types';
import IfElseConditionalRender from '@avtechsoftware/react-component-library/src/components/common/ConditionalRender/IfElseConditionalRender/IfElseConditionalRender';
import DashboardEmptyAlertMessageRender from './DashboardEmptyAlertMessageRender/DashboardEmptyAlertMessageRender';
import EmptyAlertListMessage from './EmptyAlertListMessage/EmptyAlertListMessage';

function EmptyAlertListMessageRender(props) {
  const {
    isOnDashboard,
    isPublicDashboard,
  } = props;
  return (
    <IfElseConditionalRender
      TrueComponent={DashboardEmptyAlertMessageRender}
      trueProps={{ isPublicDashboard }}
      FalseComponent={EmptyAlertListMessage}
      conditionalBool={isOnDashboard}
    />
  );
}

EmptyAlertListMessageRender.propTypes = {
  isOnDashboard: PropTypes.bool.isRequired,
  isPublicDashboard: PropTypes.bool.isRequired,
};

export default EmptyAlertListMessageRender;
